(() => {
  const run = () => {
    const english = document.documentElement.lang.toLowerCase().startsWith('en');
    const localizedPath = (path) => (english ? `/en${path}` : path);
    document.querySelectorAll('a[href^="/"]').forEach((link) => {
      const path = link.getAttribute('href');
      if (english && path && path !== '/en' && !path.startsWith('/en/')) link.setAttribute('href', localizedPath(path));
    });
    const labels = english ? { more: 'More', warranty: 'Warranty', gallery: 'Gallery' } : { more: 'Plus', warranty: 'Garantie', gallery: 'Galerie' };
    document.querySelectorAll('.mh2-primary').forEach((navigation) => {
      if (navigation.querySelector('.mh2-more')) return;
      const shop = navigation.querySelector('.mh2-shop');
      if (!shop) return;
      const more = document.createElement('details');
      more.className = 'mh2-more';
      more.innerHTML = `<summary>${labels.more}<span aria-hidden="true">+</span></summary><div><a href="${localizedPath('/pages/garantie-moosehaul')}">${labels.warranty}</a><a href="${localizedPath('/pages/galerie')}">${labels.gallery}</a></div>`;
      shop.before(more);
    });
    document.querySelectorAll('.mh2-footer-grid > div:nth-child(2) ul').forEach((list) => {
      if (list.querySelector('[href$="/pages/galerie"]')) return;
      const item = document.createElement('li');
      item.innerHTML = `<a href="${localizedPath('/pages/galerie')}">${labels.gallery}</a>`;
      list.append(item);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true }); else run();
})();
